import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import noop from 'lodash/noop';

import { SuiModal } from '@splashthat/sui';
import ImageCropper from './ImageCropper';

import { openImageCropper, closeImageCropper, setConfig } from '../../actions';

const baseClassName = 'ImageCropperModal';

class ImageCropperModal extends React.Component {
    static propTypes = {
        /* reducers */
        open: PropTypes.bool.isRequired,
        imageUrl: PropTypes.string,
        initialCrop: PropTypes.object,
        handleCropping: PropTypes.bool.isRequired,
        keepOpenWhileCropping: PropTypes.bool.isRequired,
        /* actions */
        closeImageCropper: PropTypes.func.isRequired,
        /* interface props */
        onCrop: PropTypes.func.isRequired,
        onCropError: PropTypes.func.isRequired,
        onCropSelected: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
    };

    static defaultProps = {
        imageUrl: undefined,
        initialCrop: undefined,
    };

    onCrop = (...args) => {
        if (this.props.keepOpenWhileCropping) {
            this.props.closeImageCropper();
        }

        this.props.onCrop(...args);
    };
    onCropError = (...args) => {
        if (this.props.keepOpenWhileCropping) {
            this.props.closeImageCropper();
        }
        this.props.onCropError(...args);
    };
    onCropSelected = (...args) => {
        if (!this.props.handleCropping || !this.props.keepOpenWhileCropping) {
            this.props.closeImageCropper();
        }

        this.props.onCropSelected(...args);
    };
    onCancel = (...args) => {
        this.props.closeImageCropper();
        this.props.onCancel(...args);
    };

    render() {
        return (
            <SuiModal className={`${baseClassName}_modal`} open={this.props.open} overlay={SuiModal.DARK_OPAQUE}>
                {this.props.open && (
                    <ImageCropper
                        variation="border standard-shadow flex-vertical"
                        onCancel={this.onCancel}
                        onCrop={this.onCrop}
                        onCropError={this.onCropError}
                        onCropSelected={this.onCropSelected}
                        imageUrl={this.props.imageUrl}
                        initialCrop={this.props.initialCrop}
                        handleCropping={this.props.handleCropping}
                        keepOpenWhileCropping={this.props.keepOpenWhileCropping}
                    />
                )}
            </SuiModal>
        );
    }
}

const mapStateToProps = (state, props) => {
    const { imageCropper } = state;

    // Set default values for the methods handling the modal closing behaviour.
    const {
        onCropSelected = noop,
        onCloseCropper = closeImageCropper,
        onCropError = closeImageCropper,
        onCancel = closeImageCropper,
    } = props;

    return {
        ...imageCropper,
        ...props,
        onCropSelected,
        onCloseCropper,
        onCropError,
        onCancel,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            openImageCropper,
            closeImageCropper,
            setConfig,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(ImageCropperModal);
